import React, { useEffect, useRef, useState } from "react";
import { TiArrowLeftThick, TiArrowRightThick } from "react-icons/ti";
import leaf from "../../Asset/subsribtion/leaf.png";
import Card from "./component/Card";
import AOS from "aos";
import "aos/dist/aos.css";
import categoryModel from "../../model/category.model";

const Delevery = () => {
  const scrollContainerRef = useRef(null);
  const [data, setData] = useState([]);
  const [cardsPerView, setCardsPerView] = useState(3);

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    const updateCardsPerView = () => {
      if (window.innerWidth >= 1536) {
        setCardsPerView(5);
      } else if (window.innerWidth >= 1024) {
        setCardsPerView(4);
      } else if (window.innerWidth >= 768) {
        setCardsPerView(2);
      } else {
        setCardsPerView(1);
      }
    };

    updateCardsPerView();
    window.addEventListener("resize", updateCardsPerView);
    return () => window.removeEventListener("resize", updateCardsPerView);
  }, []);

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const containerWidth = scrollContainerRef.current.offsetWidth;
      const scrollAmount = containerWidth / cardsPerView;
      if (direction === "left") {
        scrollContainerRef.current.scrollLeft -= scrollAmount;
      } else {
        scrollContainerRef.current.scrollLeft += scrollAmount;
      }
    }
  };

  const category = async () => {
    try {
      const response = await categoryModel.GetList("instant_delivery");
      setData(response?.data?.data || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    category();
  }, []);

  return (
    <div className="w-full pb-4" data-aos="fade-up">
      <div className="py-7 md:px-12 px-4">
        <div className="flex justify-between">
          <div className="flex gap-6">
            <div className="h-[55px] sm:h-full">
              <img src={leaf} alt="" className="h-full" />
            </div>
            <div className="flex flex-col">
              <span className="text-textColor text-xl md:text-4xl font-bold title">
                Deliver Now
              </span>
              <span className="text-textColor text-base md:text-xl">
                Get instant delivery for these categories
              </span>
            </div>
          </div>

          <div className="hidden sm:flex gap-4 sm:gap-6 text-3xl text-textColor">
            <div
              className="bg-textColor text-Background1 w-10 h-10 sm:w-11 sm:h-11 flex justify-center items-center rounded-full cursor-pointer"
              onClick={() => scroll("left")}
            >
              <TiArrowLeftThick />
            </div>
            <div
              className="bg-textColor text-Background1 w-10 h-10 sm:w-11 sm:h-11 flex justify-center items-center rounded-full cursor-pointer"
              onClick={() => scroll("right")}
            >
              <TiArrowRightThick />
            </div>
          </div>
        </div>

       

       <div
          ref={scrollContainerRef}
          className="sm:mt-16 mt-4 overflow-x-auto whitespace-nowrap scroll-smooth scrollbar-hide"
        >
          <div className="flex  sm:gap-10 mb-5">
            {data?.map((item, index) => (
              <div
                key={index}
                className="w-full sm:w-[100%] md:w-[50%] lg:w-[33.33%] flex-shrink-0 transition-all duration-300"
              >
                <Card item={item} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Delevery;